export default "__VITE_ASSET__65cd2a37__"